import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const PuestosDelete = ({ setOpen, id, getPuestos, mostrarAlerta, open }) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleClick = async () => {
    const puestoActualizado = { activa: 0 };
    try {
      const response = await fetch(`${UrlApi}/SP_puestos/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(puestoActualizado),
      });
      if (response.ok) {
        mostrarAlerta("El puesto ha sido eliminado correctamente", "success");
      } else {
        throw new Error("Error en la solicitud");
      }
      await getPuestos();
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
      mostrarAlerta(
        "Hubo un problema al eliminar el puesto. Intente nuevamente.",
        "error"
      );
    }

    logEventos(
      "Eliminado puesto",
      "Puestos",
      "Elimando de la DB un puesto",
      localStorage.getItem("user")
    );

    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              Eliminar puesto
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          ¿Esta seguro que quiere eliminar el puesto? Este cambio no es
          reversivle.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={handleClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={handleClick}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default PuestosDelete;
